/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6c533839"]'><cube-modal ref="__mpx_ref_modal__" title="我是标题~" content="我是正文我是正文我是正文我是正文我是正文我是正文" direction="horizontal" confirm-btn="确认按钮" cancel-btn="取消按钮" :mask-closable="(true)" @confirm='(e)=>__invoke(e, [["onConfirm"]])' @cancel='(e)=>__invoke(e, [["onCancel"]])'/><cube-button @_click="onTap">modal-水平两个按钮</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6c533839"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6c533839"}
  /** script content **/
  require("./modal-two-horizontal-btn.mpx.js?isComponent&outputPath=components%2Fmodal-two-horizontal-btn6c533839%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-two-horizontal-btn.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-two-horizontal-btn6c533839%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6c533839"],
    ctorType: "component",
    outputPath: "components/modal-two-horizontal-btn6c533839/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>